import { createContext, useContext } from "react";

import { ThemeVariant } from "./themingTypes";

export const useThemeVariant = () => useContext(ThemeVariantContext);

export const ThemeVariantContext = createContext<ThemeVariant>("default");
